<div>
    <h2>{{'gestionLicencias.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionLicencias.filters.etiquetador' | translate}}</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.almacen' | translate}}</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                    [disabled]="disabledAlmacenes" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'global.pais' | translate}}</label>
              <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionLicencias.filters.denominacion' | translate}}</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <checkbox [id]="'activada'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_activada" [label]="'gestionLicencias.filters.activada'" (refresh)="this.refreshCheckbox_activada = false" (formValue)="this.filtersForm.get('activada')?.patchValue($event)" (pristine)="pristineCheckbox('activada', $event)"></checkbox>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <checkbox [id]="'habilitada'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_habilitada" [label]="'gestionLicencias.filters.habilitada'" (refresh)="this.refreshCheckbox_habilitada = false" (formValue)="this.filtersForm.get('habilitada')?.patchValue($event)" (pristine)="pristineCheckbox('habilitada', $event)"></checkbox>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <checkbox [id]="'modoCertificado'" [initialStatus]="''" [initialRefresh]="refreshCheckboxesMode" [label]="'global.modoCertificado'" (refresh)="this.refreshCheckboxesMode = false" (formValue)="this.filtersForm.get('modoCertificado')?.patchValue($event)" (pristine)="pristineCheckbox('modoCertificado', $event)"></checkbox>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <checkbox [id]="'modoEtiqueta'" [initialStatus]="''" [initialRefresh]="refreshCheckboxesMode" [label]="'global.modoEtiqueta'" (refresh)="this.refreshCheckboxesMode = false" (formValue)="this.filtersForm.get('modoEtiqueta')?.patchValue($event)" (pristine)="pristineCheckbox('modoEtiqueta', $event)"></checkbox>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionLicencias.filters.pkc' | translate}}</label>
                <input type="text" formControlName="pkc">
            </div>
            <!--
            <div class="entry-5">
                <label>{{'gestionLicencias.filters.username' | translate}}</label>
                <input type="text" formControlName="username">
            </div> -->
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionLicencias.filters.verSoftwareInicio' | translate}}</label>
                <input type="text" formControlName="desVersionSwInicio">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionLicencias.filters.verSoftwareFin' | translate}}</label>
                <input type="text" formControlName="desVersionSwFin">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaExpInicio' | translate}}</label>
                <input [matDatepicker]="fechaExpiracionInicio" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaExpiracionInicio" (click)="fechaExpiracionInicio.open()">
                <mat-datepicker #fechaExpiracionInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaExpFin' | translate}}</label>
                <input [matDatepicker]="fechaExpiracionFin" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaExpiracionFin" (click)="fechaExpiracionFin.open()">
                <mat-datepicker #fechaExpiracionFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaUsoInicio' | translate}}</label>
                <input [matDatepicker]="fechaUltUsoInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaUltUsoInicio"
                    (click)="fechaUltUsoInicio.open()">
                <mat-datepicker #fechaUltUsoInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaUsoFin' | translate}}</label>
                <input [matDatepicker]="fechaUltUsoFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaUltUsoFin"
                    (click)="fechaUltUsoFin.open()">
                <mat-datepicker #fechaUltUsoFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaActualizadoInicio' | translate}}</label>
                <input [matDatepicker]="fechaActualizadoInicio" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaActualizadoInicio" (click)="fechaActualizadoInicio.open()">
                <mat-datepicker #fechaActualizadoInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaActualizadoFin' | translate}}</label>
                <input [matDatepicker]="fechaActualizadoFin" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaActualizadoFin" (click)="fechaActualizadoFin.open()">
                <mat-datepicker #fechaActualizadoFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaInicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'gestionLicencias.filters.fechaFin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left-next">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'gestionLicencias.filters.fechaInsercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'gestionLicencias.filters.fechaActualizacion' | translate}}</label>
            </div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="icon"></th>
                        <th class="icon">{{'gestionLicencias.table.estado' | translate}}</th>
                        <th class="id sortable" (click)="toOrderBy('x=> x.id', 3)">
                          {{'gestionLicencias.table.id' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.id')"></i></div>
                        </th>
                        <th class="id"></th>
                        <th class="string-long sortable" (click)="toOrderBy('x=> x.pkc', 5)">
                          {{'gestionLicencias.table.pkc' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.pkc')"></i></div>
                        </th>
                        <th class="string" title="{{'titles.movimientos' | translate}}">{{'gestionLicencias.table.movimiento' | translate}}</th>
                        <th class="string" title="{{'titles.activaciones' | translate}}">{{'gestionLicencias.table.activacion' | translate}}</th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.ApplicationUser.Etiquetador.Des', 8)">
                          {{'gestionLicencias.table.etiquetador' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUser.Etiquetador.Des')"></i></div>
                        </th>
                        <th class="string">{{'global.almacen' | translate}}</th>
                        <th class="action">{{'gestionLicencias.table.usuario' | translate}}</th>
                        <!-- <th *ngIf="this.role !== 'Etiquetador'" class="string">{{'gestionLicencias.table.usuario' | translate}}</th> -->
                        <th *ngIf="this.role === 'Administrador'" class="string" title="{{'titles.etqVariedad' | translate}}">{{'gestionLicencias.table.etqVariedad' | translate}}</th>
                        <th class="multi-actions-bigSubtable" *ngIf="this.role === 'Administrador' || this.claims.includes('LIC_DesactivarYDuplicar')">
                            <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" (click)="create()" title="{{'gestionLicencias.tituloNew' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <tbody class="clickable" *ngFor="let licencia of licencias; let i=index; trackBy: trackByLicenciaId">
                    <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                        <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                                title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="icon">
                            <i class="fas fa-pen-nib" *ngIf="licencia.modoCertificado" title="{{'global.modoCertificado' | translate}}" app-click-stop-propagation></i>
                        </td>
                        <td class="icon">
                            <i *ngIf="licencia.activada" class="fa-solid fa-toggle-on fa-1x" title="{{'titles.licenciaActivada' | translate}}"></i>
                            <i *ngIf="!licencia.activada" class="fa-solid fa-toggle-off fa-1x" title="{{'titles.licenciaDesactivada' | translate}}"></i>
                            <i *ngIf="licencia.habilitada" class="fa-solid fa-lock-open fa-1x" title="{{'titles.licenciaHabilitada' | translate}}"></i>
                            <i *ngIf="!licencia.habilitada" class="fa-solid fa-lock fa-1x" title="{{'titles.licenciaDeshabilitada' | translate}}"></i>
                        </td>
                        <td class="id">{{licencia.id}}</td>
                        <td class="number">
                            <i class="fa fa-copy" title="{{'titles.copiarPKC' | translate}}" app-click-stop-propagation  (click)="copyPKC(licencia)"></i>
                        </td>
                        <td class="string-long" id="copyPKCToClipboard">{{licencia.pkc}}</td>
                        <td class="string">{{licencia.numeroMovimientos}} / {{licencia.numeroMovimientosMax}}</td>
                        <td class="string">{{licencia.numeroActivaciones}} / {{licencia.numeroActivacionesMax}}</td>
                        <td class="string">{{licencia.desEtiquetador ? licencia.desEtiquetador : licencia.desJuntaLocal}}</td>
                        <td class="string">{{licencia.desAlmacenPrincipal ? licencia.desAlmacenPrincipal : ('gestionLicencias.table.sinPlanta' | translate)}}</td>
                        <td class="action">
                            <i class="fa fa-copy" title="{{'titles.copiarNombre' | translate}} ({{licencia.userName}})" app-click-stop-propagation  (click)="copyUserName(licencia)"></i>
                        </td>
                        <!-- <td *ngIf="this.role !== 'Etiquetador'" class="string" id="copyUserNameToClipboard" title=""></td> -->
                        <td *ngIf="this.role === 'Administrador'" class="string">{{licencia.etiquetadoresLicencia}} / {{licencia.variedadesLicencia}}</td>
                        <td class="multi-actions-bigger" *ngIf="this.role === 'Administrador' || this.claims.includes('LIC_DesactivarYDuplicar')">
                            <i class="fa-solid fa-power-off" *ngIf="this.role === 'Administrador' || this.claims.includes('LIC_DesactivarYDuplicar')"
                                [ngClass]="{'disabled': !(licencia.activada && licencia.habilitada)}" title="{{'titles.desactivarLicencia' | translate}}" app-click-stop-propagation
                                (click)="askDisable(licencia)"></i>
                            <i class="fas fa-clipboard-list" *ngIf="this.role === 'Administrador'" title="{{'titles.historialActivaciones' | translate}}" app-click-stop-propagation
                                (click)="openHistory(licencia)"></i>
                            <i class="fas fa-sliders-h" *ngIf="this.role === 'Administrador'" title="{{'titles.parametrizarAlmacen' | translate}}" app-click-stop-propagation
                                (click)="openParameters(licencia)"></i>
                            <i class='fas fas fa-pencil-alt' *ngIf="this.role === 'Administrador'" (click)="update(licencia)" app-click-stop-propagation title="{{'titles.editar' | translate}}"> </i>
                            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}"
                                *ngIf="this.role === 'Administrador'" (click)="askDelete(licencia)"
                                [ngClass]="{'disabled': licencia.registroEnUso}" app-click-stop-propagation ></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="14">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline">
                                    <label>{{'global.fecha.insercionShort' | translate}}</label>
                                    <p>
                                        {{licencia.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                  <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                                  <p>
                                        {{licencia.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}
                                  </p>
                              </div>
                                <div class="block-inline">
                                    <label>{{'gestionLicencias.table.fechaUltUso' | translate}}</label>
                                    <p>
                                        {{licencia.fechaUltUso ? (licencia.fechaUltUso | date: 'shortDate' : undefined : defaultLanguage) : ('gestionLicencias.table.sinFecha' | translate)}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'gestionLicencias.table.idioma' | translate}}</label>
                                    <p>
                                        {{licencia.desIdioma}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'gestionLicencias.table.versionInicial' | translate}}</label>
                                    <p>
                                        {{licencia.configuracionSwEtiquetado.desVersionInicial ?
                                        licencia.configuracionSwEtiquetado.desVersionInicial : ('gestionLicencias.table.sinVersion' | translate)}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'gestionLicencias.table.versionActual' | translate}}</label>
                                    <p>
                                        {{licencia.configuracionSwEtiquetado.desVersionActual ?
                                        licencia.configuracionSwEtiquetado.desVersionActual : ('gestionLicencias.table.sinVersion' | translate)}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'gestionLicencias.table.fechaVersion' | translate}}</label>
                                    <p>
                                        {{licencia.configuracionSwEtiquetado.fechaVersionActualEtiquetado ?
                                        (licencia.configuracionSwEtiquetado.fechaVersionActualEtiquetado | date: 'shortDate' : undefined : defaultLanguage) :
                                        ('gestionLicencias.table.sinFecha' | translate)}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'gestionLicencias.table.versionActualizar' | translate}}</label>
                                    <p>
                                        {{licencia.configuracionSwEtiquetado.desVersionPendienteActualizar ?
                                        licencia.configuracionSwEtiquetado.desVersionPendienteActualizar : ('gestionLicencias.table.sinVersion' | translate)}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'gestionLicencias.table.impresora' | translate}}</label>
                                    <p>
                                        {{licencia.configuracionSwEtiquetado.nombreDriverImpresora ?
                                        licencia.configuracionSwEtiquetado.nombreDriverImpresora : ('gestionLicencias.table.sinNombreDriver' | translate)}}
                                    </p>
                                </div>
                                <div class="block-inline">
                                  <label>{{'gestionLicencias.table.aplicacion' | translate}}</label>
                                  <p>{{ licencia.configuracionSwEtiquetado.tipoAplicacionEtqId === 1 ? aplicacion[0].des : null }}</p>
                                </div>
                                <div class="block-inline">
                                  <label></label>
                                  <p></p>
                                </div>
                                <div class="block-inline">
                                  <label></label>
                                  <p></p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!licencias || (licencias && licencias.length < 1)">
                    <tr>
                        <td colspan="14">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="licencias && licencias.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="historyModal">
    <div class="modal-content">
        <header>
            <h4>{{'gestionLicencias.tituloHistorial' | translate}}</h4>
        </header>
        <app-lic-historial class="component" [licenciaId]="licenciaId" [userName]="userName"
                (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-lic-historial>
    </div>
</div>
<div class="modal" *ngIf="parametersModal">
    <div class="modal-content" style="max-width: 96vw;">
        <header>
            <h4>{{'gestionLicencias.tituloParametros' | translate}}</h4>
        </header>
        <app-lic-parametros class="component" [licenciaId]="licenciaId" [userName]="userName"
            [licenciaJunta]="licenciaJunta" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-lic-parametros>
    </div>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="disableModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.deshabilitar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.deshabilitar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="disableLicense()">{{'global.disable' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{licenciaId ? ('gestionLicencias.tituloEdit' | translate) : ('gestionLicencias.tituloNew' | translate)}}</h4>
        </header>
        <app-lic-new-edit [licenciaId]="licenciaId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-lic-new-edit>
    </div>
</div>
